
import React, { useState, useImperativeHandle, forwardRef} from 'react'
import {  Cicon } from './Desc/style'
import closeIcon from '@/img/user-new/close-circle.png'
import styled from "styled-components"
import { jumpTo } from '@/utils'

const newCard = ({token, login},ref) => {
  
  const [descVisible, setDescVisible] = useState(false)

   useImperativeHandle(ref, () => {
    return {
      show: () => {
        setDescVisible(true)
      }
    }
  })
 
  return (

    <React.Fragment>
      {
        descVisible && <Mask className='mask' />

      }   
      {
        descVisible && <Container>
        <img src={require('../img/new.png')} onClick={
          ()=> {
             jumpTo(`/active_130`);
          }
        } alt='' className='bg'/>
        <Cicon src={closeIcon} alt="e"  onClick={() => setDescVisible(false)}></Cicon>

       </Container>
      }
    
    </React.Fragment>
  )
}

export default React.memo(forwardRef(newCard));


export const Mask = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.5);
  z-index: 999;
`



export const Container = styled.div`
  position: fixed;
  left: 40px;
  top: 50vw;
  // margin-top: -50%;
  width: calc(100vw - 80px);
  z-index: 999;
`



// WEBPACK FOOTER //
// ./src/views/activity_170/componens/newCard.js